import { useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";

export const ScreenshotUploader = ({ files, setFiles, disabled }) => {
  const inputRef = useRef();
  const [drag, setDrag] = useState(false);

  const addFiles = (list) => {
    const imgs = Array.from(list).filter((f) => f.type.startsWith("image/"));
    setFiles((prev) => [...prev, ...imgs]);
  };

  return (
    <div>
      <div
        data-testid="screenshot-dropzone"
        onClick={() => !disabled && inputRef.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); if (!disabled) addFiles(e.dataTransfer.files); }}
        className={`cursor-pointer rounded-lg border-2 border-dashed transition-colors px-6 py-10 text-center ${
          drag ? "border-primary bg-secondary" : "border-border hover:border-primary/50 hover:bg-secondary/40"
        } ${disabled ? "opacity-50 pointer-events-none" : ""}`}
      >
        <ImagePlus className="h-8 w-8 mx-auto text-muted-foreground mb-3" strokeWidth={1.5} />
        <p className="text-sm font-medium">Drop screenshots here or click to upload</p>
        <p className="text-xs text-muted-foreground mt-1">
          WhatsApp · Instagram · Facebook · LinkedIn · Email · PNG / JPG · multiple
        </p>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          multiple
          hidden
          onChange={(e) => { addFiles(e.target.files); e.target.value = ""; }}
        />
      </div>

      {files.length > 0 && (
        <div className="mt-4 grid grid-cols-4 sm:grid-cols-6 gap-3">
          {files.map((f, i) => (
            <div key={i} className="relative group aspect-square rounded-md overflow-hidden border border-border">
              <img src={URL.createObjectURL(f)} alt="" className="h-full w-full object-cover" />
              {!disabled && (
                <button
                  data-testid={`remove-screenshot-${i}`}
                  onClick={() => setFiles((prev) => prev.filter((_, idx) => idx !== i))}
                  className="absolute top-1 right-1 bg-black/70 text-white rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <X className="h-3.5 w-3.5" />
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
